import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  FieldSet,
  RadioGroupInput,
  FormGroup,
  CustomDatePicker,
  NestedFieldSet,
  FormGroupSelect,
} from "components/formElements";
import {
  Fresher,
  LessThanOneYear,
  MoreThanOneYear,
} from "components/formGroups";
import { getOptions, getDateNMonthsAgo } from "util/library";

const options = [
  {
    text: "Yes",
    value: true,
  },
  {
    text: "No",
    value: false,
  },
];

const ProfessionalDetails = ({
  handleChange,
  graduationStreams,
  postGraduationStreams,
  skills,
  workExperienceError,
  workExperience,
  workExperiences,
  isCandidateOnNotice,
  lastWorkingDay,
  noticePeriod,
  jobPosting,
  noticePeriods,
  handleLastWorkingDayChange,
  handleProfessionalDetailsChange,
  state,
  setState,
  ...rest
}) => {
  const { minExp, jobPostingId } = jobPosting;
  useEffect(() => {
    if (jobPostingId !== null) {
      if (minExp >= 1 && minExp < 2) {
        let arr = workExperiences.filter((item) => item.value !== 0);
        setState({
          ...state,
          workExperiences: arr,
        });
      } else if (minExp >= 2) {
        let arr = [];
        setState({
          ...state,
          workExperiences: arr,
          professionalDetails: {
            ...state.professionalDetails,
            workExperience: "20",
          },
        });
      }
      return;
    }
    return;
  }, [workExperiences.length, workExperience]);

  const noticePeriodFields = (
    <NestedFieldSet>
      <FormGroup>
        <RadioGroupInput
          label="Are you on Notice?"
          name="isCandidateOnNotice"
          options={options}
          handleOptionChange={handleChange}
          inlineRadio
          value={isCandidateOnNotice}
        />
      </FormGroup>
      {isCandidateOnNotice &&
        (isCandidateOnNotice === "true" ? (
          <CustomDatePicker
            id="lastWorkingDay"
            name="lastWorkingDay"
            type="date"
            label="Last Working Day"
            selected={lastWorkingDay}
            onChange={handleLastWorkingDayChange}
            dateError={false}
            errorMessage=""
            openToDateYearRange={new Date()}
            minDateYearRange={new Date()}
            maxDateYearRange={getDateNMonthsAgo(-3)}
          />
        ) : (
          <FormGroupSelect
            id="noticePeriod"
            name="noticePeriod"
            label="How soon can you join after receiving offer?"
            value={noticePeriod}
            onChange={handleChange}
            options={getOptions(noticePeriods, "Select an option")}
            required
          />
        ))}
    </NestedFieldSet>
  );

  return (
    <FieldSet legendText="Professional Details">
      {jobPostingId !== null && minExp >= 2 && workExperience === "20" ? (
        null
      ) : (
        <RadioGroupInput
          label="Work Experience"
          name="workExperience"
          options={workExperiences}
          handleOptionChange={handleChange}
          error={workExperienceError}
          required
          indent
          inlineRadio
          value={workExperience}
        />
      )}

      {workExperience === "0" && (
        <Fresher
          {...rest}
          handleChange={handleChange}
          graduationStreams={graduationStreams}
          postGraduationStreams={postGraduationStreams}
          skills={skills}
        />
      )}
      {workExperience === "10" && (
        <LessThanOneYear
          {...rest}
          handleChange={handleChange}
          graduationStreams={graduationStreams}
          postGraduationStreams={postGraduationStreams}
          skills={skills}
          options={options}
          noticePeriodFields={noticePeriodFields}
        />
      )}
      {workExperience === "20" && (
        <MoreThanOneYear
          {...rest}
          skills={skills}
          handleChange={handleChange}
          options={options}
          noticePeriodFields={noticePeriodFields}
        />
      )}
    </FieldSet>
  );
};

ProfessionalDetails.propTypes = {
  handleChange: PropTypes.func.isRequired,
  graduationStreams: PropTypes.array.isRequired,
  postGraduationStreams: PropTypes.array.isRequired,
  skills: PropTypes.array.isRequired,
  workExperiences: PropTypes.array.isRequired,
};

export { ProfessionalDetails };
